import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderNavigation from '../../components/ui/HeaderNavigation';
import AuthTabs from './components/AuthTabs';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import SecurityBadges from './components/SecurityBadges';
import Icon from '../../components/AppIcon';

const Authentication = () => {
  const [activeTab, setActiveTab] = useState('login');

  return (
    <div className="min-h-screen bg-background">
      <HeaderNavigation />

      <div className="content-wrapper">
        <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-8 md:py-12">
          <div className="w-full max-w-md">
            <div className="text-center mb-6 md:mb-8">
              <Link to="/landing-page" className="inline-flex items-center justify-center gap-3 mb-4">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center bg-gradient-to-br from-primary to-accent">
                  <Icon name="Code2" size={28} color="#FFFFFF" />
                </div>
              </Link>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
                Welcome to Giati Builder
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                {activeTab === 'login' ?'Sign in to continue building amazing projects' :'Create your account and start generating code'}
              </p>
            </div>

            <div className="bg-card rounded-xl shadow-2xl p-6 md:p-8 border border-border">
              <AuthTabs activeTab={activeTab} onTabChange={setActiveTab} />

              {activeTab === 'login' ? <LoginForm /> : <RegisterForm />}

              <SecurityBadges />
            </div>

            <div className="mt-6 text-center">
              <p className="text-sm text-muted-foreground">
                {activeTab === 'login' ? (
                  <>
                    Don't have an account?{' '}
                    <button
                      onClick={() => setActiveTab('register')}
                      className="text-primary hover:underline font-medium"
                    >
                      Sign up for free
                    </button>
                  </>
                ) : (
                  <>
                    Already have an account?{' '}
                    <button
                      onClick={() => setActiveTab('login')}
                      className="text-primary hover:underline font-medium"
                    >
                      Sign in
                    </button>
                  </>
                )}
              </p>
            </div>

            <div className="mt-8 text-center">
              <p className="text-xs text-muted-foreground">
                By continuing, you agree to our{' '}
                <button className="text-primary hover:underline">Terms of Service</button>
                {' '}and{' '}
                <button className="text-primary hover:underline">Privacy Policy</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Authentication;